import React, { useState, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import _ from "lodash"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import gql from "graphql-tag"
import { useQuery } from "@apollo/client"
import LeftConvList from "./LeftConvList"
import TRSMSIndex from "../SMS/TRSMSIndex"
import ParticipantSMSNew from "./ParticipantSMSNew"
import LoaderFullPage from "../../../components/Loaders"
import { ReactComponent as NoChatsIcon } from "../resources/no_chats_icon.svg"
import { Button } from "primereact/button"
import { sortListByDate } from "../Utils"
import { PARTICIPANT_BLOCK } from "../../Participant/ParticipantProfile/queries"

export default function MySMSChatsTab({ staffPhoneNumber }) {

  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [participants, setParticipants] = useState(null)
  const [hasConvs, setHasConvs] = useState(null)
  const [newParticipantSMS, setNewParticipantSMS] = useState(false)
  const [selectedConv, setSelectedConv] = useState(null)
  const [convList, setConvList] = useState(null)
  const [isOkayToText, setIsOkayToText] = useState(null)

  const { refetch: refetchParticipantContactInfo } = useQuery(PARTICIPANT_BLOCK, {
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: user.organization_id,
      enterprise_id: user.enterprise_id,
      idBlock: "participant__contact_information",
    },
    skip: true,
  })

  const isOkToTextParticipant = async (participantId) => {
    const res = await refetchParticipantContactInfo({
      participant_id: participantId,
      organization_id: user.organization_id,
      enterprise_id: user.enterprise_id,
      idBlock: "participant__contact_information"
    })
    if (res.data && res.data.blockSaved && res.data.blockSaved.data) {
      const parsedData = JSON.parse(res.data.blockSaved.data)
      const okToText = parsedData &&
        parsedData.values.participant_phone_primary_preference.find(
          (s) => s === "Okay to text"
        ) ? true : false
      return okToText
    }
  }

  const GET_PARTICIPANTS = gql`
  query GetParticipants(
    $staff_id: ID!
    $organization_id: ID!
    $search_type: String
  ) {
    participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: $search_type
    ) {
      participant_id
      participant_name_first
      participant_name_last
      participant_phone_primary,
      participant_membership_status
    }
  }
`

  const { loading } = useQuery(GET_PARTICIPANTS, {
    variables: {
      staff_id: user.staff_id,
      organization_id: user.organization_id,
      search_type: "all_participants",
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setParticipants(
        _.map(data.participantAdvancedSearch, (participant) => {
          return {
            ...participant,
            name: `${_.unescape(
              participant.participant_name_first
            )} ${_.unescape(participant.participant_name_last)}`,
            initials: `${_.unescape(participant.participant_name_first).charAt(0)}${_.unescape(participant.participant_name_last).charAt(0)}`
          }
        })
      )
    },
  })

  const onMessageSent = async (conv) => {
    const isOkToText = await isOkToTextParticipant(conv.caseId)
    setIsOkayToText(isOkToText)
    setSelectedConv({ sid: conv.caseId, participant: { id: conv.caseId, phone: conv.casePhone, name: conv.caseName, initials: conv.caseInitials } })
    setConvList([conv, ...convList])
    setHasConvs(true)
    setNewParticipantSMS(false)
  }

  const updateConv = (newMsg) => {
    let updatedConvs = convList.map((conv) => {
      if (conv.casePhone === newMsg.from) {
        return {
          ...conv,
          lastMessageDate: newMsg.dateUpdated,
          containsUnread: (selectedConv.participant.id !== newMsg.from) ? true : conv.containsUnread
        }
      } else if (selectedConv.sid === conv.sid && newMsg.from === staffPhoneNumber) {
        return {
          ...conv,
          lastMessageAt: newMsg.dateUpdated
        }
      }
      return conv
    })
    sortListByDate(updatedConvs, "lastMessageAt")
    setConvList(updatedConvs)
  }

  if (loading) {
    return <LoaderFullPage />
  }

  if (convList && !newParticipantSMS && !hasConvs && !selectedConv) {
    return (
      <div className={gMessages.wrapperNoChats}>
        <NoChatsIcon />
        <h3>
          Start a conversation now
        </h3>
        <Button
          className={`custom_button_icon ${gMessages.newChatBtn}`}
          style={{ marginTop: "30px" }}
          label="New Message"
          icon="pi pi-plus"
          onClick={() => setNewParticipantSMS(true)} />
      </div>
    )
  }

  return (
    <div className={styles.wrapper} style={{ minHeight: "600px", margin: "0px" }}>
      {staffPhoneNumber && participants && (
        <LeftConvList
          participants={participants}
          openNewParticipantChat={() => {
            setNewParticipantSMS(true)
            setIsOkayToText(null)
            setSelectedConv(null)
          }}
          openConv={async (conv) => {
            const participant = participants.find((p) => p.participant_id === conv.participant.id)
            const isOkToText = await isOkToTextParticipant(conv.participant.id)
            setIsOkayToText(isOkToText)
            setSelectedConv({ ...conv, participant: { ...conv.participant, membership_status: participant.participant_membership_status } })
            setNewParticipantSMS(false)
          }}
          setHasConvs={setHasConvs}
          convList={convList}
          setConvList={setConvList}
          staffNumber={staffPhoneNumber}
        ></LeftConvList>
      )}
      <>
        {!newParticipantSMS &&
          hasConvs &&
          staffPhoneNumber &&
          participants && (
            <TRSMSIndex
              staffPhoneNumber={staffPhoneNumber}
              selectedConv={selectedConv}
              onNewMessage={updateConv}
              isOkayToText={isOkayToText}
            />
          )}
        {newParticipantSMS === false && hasConvs === false && (
          <div className={gMessages.wrapperNoChats}>
            <NoChatsIcon />
            <h3>
              Start a conversation now
            </h3>
            <Button
              className={`custom_button_icon ${gMessages.newChatBtn}`}
              style={{ marginTop: "30px" }}
              label="New Message"
              icon="pi pi-plus"
              onClick={() => setNewParticipantSMS(true)} />
          </div>
        )}
        {newParticipantSMS && staffPhoneNumber && (
          <ParticipantSMSNew
            staffPhoneNumber={staffPhoneNumber}
            onMessageSent={onMessageSent}
          />
        )}
      </>
    </div>
  )
}
